import React, { useEffect, useState } from 'react';

import { useSession } from '../../providers/SessionProvider';
import api from '../../services/api';
import { REACT_APP_AWS_BUCKET_PATH } from '../../utils/config';

import ContentHeader from '../../components/ContentHeader';
import Footer from '../../components/Footer';
import MainHeader from '../../components/MainHeader';
import SideMenu from '../../components/SideMenu';
import MyLoadingOverlay from '../../components/MyLoadingOverlay';

import imgContrato from '../../assets/images/img-contrato.jpg';

function Contracts() {
  const { _token } = useSession();
  const { setIsAssessoryMenuSelected, isLoading, setIsLoading } = useSession();
  const [contracts, setContracts] = useState([]);

  const loadContracts = async () => {
    const config = {
      headers: { Authorization: `Bearer ${_token}` },
    };

    setIsLoading(true);

    await api.get('/api/contracts', config).then(response => {
      const { data } = response.data;
      setContracts(data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setIsAssessoryMenuSelected(true);
    loadContracts();
  }, []);

  return (
    <div className="interna gray">
      <div className="white" />
      <div className="container bug-height">
        <div className="row first-row">
          <div className="col grid_3 left-menu">
            <MainHeader />
            <SideMenu />
          </div>
          <div className="col grid_9 content">
            <ContentHeader />
            <h3>Assessoria Jurídica - Modelos de Contratos:</h3>
            {contracts && (
              <div className="docs" style={{ minHeight: 300 }}>
                {contracts.map(contract => (
                  <a
                    key={String(contract.id)}
                    href={`${REACT_APP_AWS_BUCKET_PATH}/uploads/contracts/${contract.filename}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="image">
                      <img
                        src={imgContrato}
                        width="365"
                        height="244"
                        alt="Contrato"
                      />
                    </div>
                    <p>{contract.description}</p>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
      {isLoading && <MyLoadingOverlay />}
    </div>
  );
}

export default Contracts;
